
import React, { useState, useEffect } from 'react';
import { Marker } from '@react-google-maps/api';

const UserLocationMarker = () => {
  const [position, setPosition] = useState<{lat: number, lng: number} | null>(null);
  
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          console.error("Error getting user's location:", error);
        }
      );
    }
  }, []);
  
  return position && window.google && window.google.maps ? (
    <Marker
      position={position}
      icon={{
        url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='%234a9edb' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Ccircle cx='12' cy='12' r='3'%3E%3C/circle%3E%3C/svg%3E",
        scaledSize: new window.google.maps.Size(24, 24),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(12, 12)
      }}
    />
  ) : null;
};

export default UserLocationMarker;
